export default __webpack_public_path__ + "static/media/raid__cloud__castle.0c416867.png";